export enum JobStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  ARCHIVED = 'ARCHIVED',
}

export enum JobListingType {
  DRIVER = 'DRIVER',
  OFFICE = 'OFFICE',
}
